import {
  CashbackIcon,
  MinusSignIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { ApplicationFeeStatus, FeeStatusItem } from "shared/types";
import { cx, formatToCurrency, has } from "shared/utils";
import { Check } from "untitledui-js-base";
import { formatTitleFirstWord } from "utils/formatTitle";

const iconMap = {
  [ApplicationFeeStatus.Paid]: (
    <Check size="20" className="stroke-success-600" />
  ),
  [ApplicationFeeStatus.Refunded]: (
    <HugeiconsIcon icon={CashbackIcon} className="text-warning-500" size={20} />
  ),
  [ApplicationFeeStatus.Unpaid]: (
    <HugeiconsIcon
      icon={MinusSignIcon}
      size={20}
      className="text-content-100"
    />
  )
};

export const FeeStatusDisplay = ({ fee }: { fee: FeeStatusItem }) => {
  if (fee.status === "not_applicable") return;
  return (
    <div className="space-y-2">
      <p className="text-xs font-normal text-content-300">{fee.description}</p>
      <div className="flex gap-2 items-center text-sm">
        {iconMap[fee.status]}
        <p
          className={cx(
            "font-medium",
            fee.status === "unpaid" ? "text-content-200" : "text-content-1000"
          )}
        >
          {formatTitleFirstWord(fee.status)}
        </p>
        <p
          className={cx(
            fee.status === "unpaid" ? "text-content-200" : "text-content-300"
          )}
        >
          (
          <span>
            {fee.status === "refunded" &&
              `${formatToCurrency(fee.refunded_amount, {
                minimumFractionDigits: 2
              })} of `}
          </span>
          <span>
            {has(fee.amount) &&
              formatToCurrency(fee.amount, {
                minimumFractionDigits: 2
              })}
          </span>
          )
        </p>
      </div>
    </div>
  );
};
